import { Tag } from 'antd'
import { Link } from 'react-router-dom'

interface Props {
  title: string
  target?: string
  status?: string
}

export const TaskTitle = ({ title, target, status }: Props) => {
  return (
    <span>
      {status && <Tag>{status}</Tag>}

      {title}
      {target && <Link to="#">{target}</Link>}
    </span>
  )
}
